/* eslint-disable react/prop-types */
/**
 * 商家档案模块 · 样式系统（基于项目已有的 antd）
 * ------------------------------------------------------------------
 * 这一层只负责「长什么样」，不含业务逻辑与接口调用。
 * 商家档案 / 经营看板 / 商家成员 / 会员信息 四个一级 tab 全部复用它。
 */
import React from 'react';
import { Grid } from 'antd';

import styles from './StatGroup.less';

export { default as SectionCard } from './SectionCard';
export { default as StatCard } from './StatCard';
export { default as ChartCard } from './ChartCard';
export { default as InfoGrid } from './InfoGrid';
export { default as FilterDropdown } from './FilterDropdown';
export { default as EmptyState } from './EmptyState';
export { default as SubNav } from './SubNav';
export { default as CapsuleStat } from './CapsuleStat';
export { default as FunnelBars } from './FunnelBars';
export { default as MemberList } from './MemberList';
export { default as RankBars } from './RankBars';
export { default as DistributionDonut } from './DistributionDonut';
export { default as FilterChips } from './FilterChips';
export { AnchorNav, AnchorLayout } from './AnchorNav';
export { default as DataTable } from './DataTable';
export { default as LazyMount } from './LazyMount';
export { default as PosterWall } from './PosterWall';

/* 常用 antd 原子件从这里统一取，业务侧不再各自 import 组件库 */
export {
  Avatar,
  Badge,
  Button,
  Card,
  Descriptions,
  Divider,
  Dropdown,
  Empty,
  Grid,
  Image,
  List,
  Menu,
  Popover,
  Radio,
  Space,
  Spin,
  Statistic,
  Switch,
  Tabs,
  Tag,
  Tooltip,
  Typography,
} from 'antd';

const { Row, Col } = Grid;

/**
 * StatGroup —— 指标卡栅格容器
 * 商家端看板的 KPI 区基本都是 4 列（截图中「核心指标」即 4 张卡一排），
 * 这里给一个带固定间距的容器，避免各处手写 gutter。
 *
 * @param span   单卡占 antd 24 栅格的列宽，默认 6（一排 4 个）
 * @param gutter 水平间距，默认 12
 */
export const StatGroup = (props) => {
  const { children, span = 6, gutter = 12, className } = props;

  const cells = React.Children.toArray(children).filter(Boolean);
  if (!cells.length) return null;

  return (
    <Row gutter={gutter} className={`${styles.row} ${className || ''}`}>
      {cells.map((child, index) => (
        <Col
          key={index}
          span={child.props && child.props.span ? child.props.span : span}
        >
          {child}
        </Col>
      ))}
    </Row>
  );
};

export { Row, Col };
